module.exports = __webpack_public_path__ + "media/page-1.d8f36738.mp3";